/**
 * Kopinas: replaces Dawn's plain quantity stepper with price-tier "cards"
 * (1 / 2 / 3 / 4 o más placas) so the volume discount is visible on the
 * product page. Drives the real #Quantity-{sectionId} input Dawn already
 * submits with the add-to-cart form — no changes to product-form.js.
 *
 * The tier table below must match the 4 automatic discounts configured in
 * Shopify admin (Descuentos): 2+ -> 17,50€/ud, 3+ -> 16€/ud, 4+ -> 14€/ud,
 * 10+ -> 12€/ud. Update both places together if pricing changes.
 */
(function () {
  const TIERS = [
    { min: 1, unit: 20 },
    { min: 2, unit: 17.5 },
    { min: 3, unit: 16 },
    { min: 4, unit: 14 },
    { min: 10, unit: 12 },
  ];

  function unitPriceFor(qty) {
    let unit = TIERS[0].unit;
    for (const tier of TIERS) {
      if (qty >= tier.min) unit = tier.unit;
    }
    return unit;
  }

  function formatEUR(amount) {
    const rounded = Math.round(amount * 100) / 100;
    return rounded.toLocaleString('es-ES', {
      minimumFractionDigits: rounded % 1 ? 2 : 0,
      maximumFractionDigits: 2,
    }) + '€';
  }

  function setupPicker(root) {
    const sectionId = root.dataset.sectionId;
    const input = document.getElementById('Quantity-' + sectionId);
    const wrapper = document.getElementById('Quantity-Form-' + sectionId);
    if (!input || !wrapper || root.dataset.kopinasInit) return;
    root.dataset.kopinasInit = 'true';

    const cards = Array.from(root.querySelectorAll('.kopinas-qty__card'));
    const moreControls = root.querySelector('[data-more-controls]');
    const totalDisplay = root.querySelector('[data-total-display]');

    function updateUI(qty) {
      const activeCardQty = qty >= 4 ? 4 : qty;
      cards.forEach((card) => {
        const isActive = Number(card.dataset.qty) === activeCardQty;
        card.classList.toggle('is-selected', isActive);
        card.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      const isMore = qty >= 4;
      if (moreControls) moreControls.hidden = !isMore;
      wrapper.classList.toggle('kopinas-qty__native--visible', isMore);

      if (isMore && totalDisplay) {
        const unit = unitPriceFor(qty);
        totalDisplay.textContent =
          qty + ' placas · ' + formatEUR(unit) + '/ud · Total ' + formatEUR(qty * unit);
      }
    }

    function selectQty(qty, focusInput) {
      qty = Math.max(1, qty);
      if (input.value != qty) {
        input.value = qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateUI(qty);
      if (focusInput) input.focus();
    }

    cards.forEach((card) => {
      card.setAttribute('role', 'radio');
      card.addEventListener('click', () => {
        const qty = Number(card.dataset.qty);
        selectQty(qty, qty >= 4);
      });
    });

    input.addEventListener('change', () => {
      updateUI(Math.max(1, parseInt(input.value, 10) || 1));
    });

    updateUI(Math.max(1, parseInt(input.value, 10) || 1));
  }

  function init() {
    document.querySelectorAll('.kopinas-qty').forEach(setupPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();